<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: null
    },
    collapsed: {
      type: String,
      default: '0'
    }
  }
}
</script>

<template>
  <div class="text">
    <el-collapse value="0">
      <el-collapse-item :name="collapsed">
        <template #title>
          <span>
            {{ title}}
            <el-tooltip v-if="description" :content="description" placement="top" class="item" effect="dark">
              <i class="el-icon-info"></i>
            </el-tooltip>
          </span>
        </template>
        <div class="body">
          <slot></slot>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

.body {
  padding: 10px;
}

/deep/ .el-collapse-item__header {
  font-size: 14px;
  color: $font-dark-color;
  font-weight: bold;
  font-family: 'Poppins', sans-serif;
}

.text-collapse.text >>> .el-collapse-item__header{
  color: #ff0000 !important;
}

.item {
  font-family: 'Poppins', sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Collapse/CollapseChild.vue